import { render } from "./App.vue?vue&type=template&id=00f95d9b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=00f95d9b&lang=css"
script.render = render

export default script